import { APIS } from "../../app/utils/constants/apiConstant";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { protectedApi } from "../../app/utils/common/protectedApi";

export const logIn = createAsyncThunk(
  "auth/logIn",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await protectedApi({
        url: APIS.LOG_IN,
        method: "POST",
        data: {
          email,
          password,
        }
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.error);
    }
  }
);
export const refreshTokenAPI = createAsyncThunk(
  "auth/refreshTokenAPI",
  async ({ refreshToken }, { rejectWithValue }) => {
    try {
      const response = await protectedApi({
        url: APIS.REFRESH_TOKEN,
        method: "POST",
        data: {
          refreshToken
        }
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.error);
    }
  }
);

// Synchronous lock so two callers in the same tick cannot both pass `condition`.
let profileInFlight = false;

export const getUserProfile = createAsyncThunk(
  "auth/getUserProfile",
  async (_arg, { rejectWithValue }) => {
    try {
      const response = await protectedApi({
        url: APIS.USER_PROFILE,
        method: "GET"
      });

      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data?.error || error);
    } finally {
      profileInFlight = false;
    }
  },
  {
    // Skip if profile already loaded, or a fetch is already running.
    // Pass `{ force: true }` after password/profile updates.
    condition: (arg, { getState }) => {
      const force = Boolean(arg && arg.force);
      const { user, isAuth } = getState().auth.auth;
      if (!force && isAuth && user) return false;
      if (!force && profileInFlight) return false;
      profileInFlight = true;
      return true;
    },
  }
);

/** Shared entry point — dedupes remounts / multiple subscribers. */
export const ensureUserProfile = (dispatch, { force = false } = {}) => {
  return dispatch(getUserProfile(force ? { force: true } : undefined));
};

export const updateUserApi = createAsyncThunk(
  "auth/updateUserApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await protectedApi({
        url: APIS.UPDATE_USER_PROFILE,
        method: "PUT",
        data
      });

      return response.data;
    } catch (error) {
      console.log(error)
      return rejectWithValue(error.response.data.error);
    }
  }
);

export const changePasswordAPI = createAsyncThunk(
  "auth/changePasswordAPI",
  async ({ currentPassword, newPassword, confirmPassword }, { rejectWithValue }) => {
    try {
      const response = await protectedApi({
        url: APIS.CHANGE_PASSWORD,
        method: "PUT",
        data: {
          currentPassword,
          newPassword,
          confirmPassword,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.error || error);
    }
  }
);
